import InputWrapper from '../InputWrapper';

interface Props {
  name: string,
  label: string,
  value: string,
  maxLength?: number,
  rows?: number,
  onChange(e: any): void,
  required: boolean
}

export const Textarea = ({name, label, value, maxLength, rows, onChange, required}: Props) => {
  return (
    <InputWrapper label={label}>
      <textarea
        name={name}
        id={name}
        placeholder={label}
        value={value}
        maxLength={maxLength}
        rows={rows}
        onChange={e => onChange(e)}
        required={required}
      />
    </InputWrapper>
  )
}

export default Textarea;
